<template>
  <div>
    <el-dialog v-dialogDrag class="setting" title="设置" :visible.sync="isShow" width="600px">
      <el-tabs v-model="tabValue" tab-position="left" style="min-height: 400px;" @tab-click="onClickTab">
        <el-tab-pane label="个人资料">
          <personal-info ref="personalInfo" @showQrcodeCall="handleShowQrcode"></personal-info>
        </el-tab-pane>
        <el-tab-pane label="用户设置">
          <user-config ref="userConfig"></user-config>
        </el-tab-pane>
        <el-tab-pane label="修改密码">
          <change-password ref="changePassword"></change-password>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
    <Qrcode :id="userInfo.id" @close="closeQrcode" :name="userInfo.nickName" v-if="showQrcode" :headImage="userInfo.headImage"></Qrcode>
  </div>

</template>

<script>
import Qrcode from "../common/Qrcode.vue";
import PersonalInfo from './PersonalInfo.vue';
import UserConfig from './UserConfig.vue';
import ChangePassword from './ChangePassword.vue';

export default {
  name: "setting",
  components: {
    PersonalInfo,
    UserConfig,
    ChangePassword,
    Qrcode
  },
  data() {
    return {
      isShow: false,
      tabValue: "0",
      showQrcode: false,
    }
  },
  computed: {
    userInfo() {
      return JSON.parse(JSON.stringify(this.$store.state.userStore.userInfo))
    }
  },
  methods: {
    handleShowQrcode() {
      this.showQrcode = true;
    },
    closeQrcode() {
      this.showQrcode = false;
    },
    open() {
      this.tabValue = "0";
      this.isShow = true;
      this.$nextTick(() => this.onClickTab())
    },
    onClickTab() {
      if (this.tabValue == "0") {
        this.$refs.personalInfo.init();
      }else if(this.tabValue == "1"){
        this.$refs.userConfig.init(); 
      }else if(this.tabValue == "2"){
        this.$refs.changePassword.init();
      }
    },
    handleClose() {
      this.isShow = false;
    }
  },
  props: {
    visible: {
      type: Boolean
    }
  }

}
</script>

<style lang="scss"></style>
